import {IEventManagerWithAsync} from '@gongxigames/framework/core';
import {Message} from '@gongxigames/framework/slot/types';
import {formatClockTime, getElapsedTime} from '@gongxigames/framework/slot/utils';

export class ElapsedClockCounter {
    private eventManager!: IEventManagerWithAsync;
    private startDate = 0;
    private isInvisible = false;
    private isGamePaused = false;
    private pauseReason?: Message;

    public init(startDate: number,eventManager: IEventManagerWithAsync): void {
        this.startDate = startDate;
        this.eventManager = eventManager;
        this.addEvents();
    }

    public getTime(): string {
        const elapsedTime = formatClockTime(getElapsedTime(this.startDate));

        return elapsedTime;
    }

    public get isPaused(): boolean {
        return this.isInvisible || this.isGamePaused;
    }

    protected addEvents(): void {
        this.eventManager.on('General.Screen.BECAME_VISIBLE', this.onBecameVisible.bind(this), this);
        this.eventManager.on('General.Screen.BECAME_INVISIBLE', this.onBecameInvisible.bind(this), this);
        this.eventManager.on('General.Message.SHOW', this.onGeneralMessageShown.bind(this), this);
        this.eventManager.on('General.Message.CLOSE', this.onGeneralMessageClosed.bind(this), this);
    }

    protected onBecameInvisible(): void {
        this.isInvisible = true;
    }

    protected onBecameVisible(): void {
        this.isInvisible = false;
    }

    protected onGeneralMessageShown(message: Message): void {
        if (message.type === 'error') {
            this.pause(message);
        }
    }

    protected pause(pauseReason: Message): void {
        this.isGamePaused = true;
        this.pauseReason = pauseReason;
    }

    protected onGeneralMessageClosed(message: Message): void {
        if (message?.type === 'error') {
            this.resume(message);
        }
    }
    protected resume(resumeReason: Message): void {
        if (resumeReason.id === this.pauseReason?.id) {
            this.isGamePaused = false;
            this.pauseReason = undefined;
        }
    }
}
